import {observable} from '@api'
import {deployments, globalStores, ISiteDeployment} from '@stores/index'
import {synchronizeStores} from '@stores/SynchronizeStores'
import {action, autorun, computed, runInAction, trace} from 'mobx'
import config from '../../config/index'
import {_} from '../../shared/components/3rd-party'

export class ConfigStore {
  @observable isTesting = false
  constructor() {
    synchronizeStores(() => {
      autorun(() => {
        document.body.setAttribute('data-test', this.isTesting.toString())
      })

      DEBUG && autorun(() => {
        const {deployments: {selectedDeploymentId}} = globalStores

        selectedDeploymentId && runInAction(() => {
          const {deployments: {selectedDeployment}} = globalStores
          if (selectedDeployment) {
            const d = selectedDeployment
            let url = _.trim(d.url, '/')
            let gatewayEndpoint = _.trim(d.gatewayEndpoint, '/')
            configs.config = Object.assign(
              {},
              d,
              {
                deployment: d._id,
                apiGatewayEndpoint: d.apiGatewayEndpoint ?? (d.environment !== 'localhost' ? `${url}/design-board-api-gateway/` : gatewayEndpoint ? `${gatewayEndpoint}` : `${url}`),
                graphqlEndpoint: d.graphqlEndpoint ?? (d.environment !== 'localhost' ? `${url}/design-board-graphql/` : `${url}/`),
                servicesUrl: d.servicesUrl ? d.servicesUrl : `${url}/services/`,
                secondaryServicesUrl: d.secondaryServicesUrl,
                mediaMicroserviceEndpoint: d?.mediaUrl ? `${d?.mediaUrl}/centric-media-microservice/` : `${url}/centric-media-microservice/`,
                centricURL: d.centricURL,
                plmC8URL: d?.plmC8URL ?? d.centricURL,
                imgProxyUrl: d?.imgProxyUrl ?? `${url}/images`,
                loginPageBgImage: d?.loginPageBgImage
              } as Partial<ISiteDeployment>)
          }
        })
      }, {name: `Update config when selected deployment changes`})
    })
  }
  @observable config : Partial<ISiteDeployment> = config
  @observable.ref originalConfig: Partial<ISiteDeployment> = config
  @computed get apiRoot() {
    const {config: {apiGatewayEndpoint}} = this
    return apiGatewayEndpoint.substring(0, apiGatewayEndpoint.indexOf('/', 9)) // Start after https://
  }

  @computed get deployment() {
    return deployments.deploymentConfig
  }

  @observable showNotificationsConfig = false
  @action toggleShowNotificationsConfig = () => {
    this.showNotificationsConfig = !this.showNotificationsConfig
  }

  __debug = DEBUG
  __platform = DEBUG ? PLATFORM : null
  __hostname = DEBUG ? HOSTNAME : null
  __build_user = DEBUG ? BUILD_USER : null
  __branch = DEBUG ? GIT_BRANCH : null
  __commit = DEBUG ? GIT_COMMIT : null
}

export const configs = new ConfigStore()

export const SERVICE_URLS = {
  VLP_EXPORT_IMAGES: `${configs.config.graphqlEndpoint}images/vlp/merchoptions/images`,
}


// WEBPACK FOOTER //
// ./src/stores/config/Configs.ts